import { useForm } from "@inertiajs/react";
import { bizminer_app_password_reset_path } from "@/_generated/routes/routes";
import type BizminerOrganizationDisplay from "@/_generated/types/serializers/BizminerOrganizationDisplay";
import { AuthCard } from "@/components/auth/AuthCard.tsx";
import { Button } from "@/components/ui/button.tsx";
import { Input } from "@/components/ui/input.tsx";
import { Label } from "@/components/ui/label.tsx";

interface Props {
  email: string;
  token: string;
  organization_slug: string;
  organization?: BizminerOrganizationDisplay;
}

export default function Edit({
  email,
  token,
  organization_slug,
  organization,
}: Props) {
  const { data, setData, patch, processing, errors } = useForm({
    password: "",
    password_confirmation: "",
  });

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    patch(bizminer_app_password_reset_path(organization_slug, token));
  };

  return (
    <AuthCard
      organization={organization}
      subtitle={`Enter a new password for ${email}`}
    >
      <form onSubmit={handleSubmit}>
        <div className="flex flex-col gap-4">
          <div className="grid gap-2">
            <Label htmlFor="password">New password</Label>
            <Input
              id="password"
              name="password"
              type="password"
              autoComplete="new-password"
              placeholder="New password"
              value={data.password}
              onChange={(e) => setData("password", e.target.value)}
              required
              minLength={6}
            />
            {errors.password && (
              <p className="text-sm text-destructive">{errors.password}</p>
            )}
          </div>
          <div className="grid gap-2">
            <Label htmlFor="password_confirmation">Confirm password</Label>
            <Input
              id="password_confirmation"
              name="password_confirmation"
              type="password"
              autoComplete="new-password"
              placeholder="Confirm password"
              value={data.password_confirmation}
              onChange={(e) => setData("password_confirmation", e.target.value)}
              required
              minLength={6}
            />
            {errors.password_confirmation && (
              <p className="text-sm text-destructive">
                {errors.password_confirmation}
              </p>
            )}
          </div>
          <Button type="submit" className="w-full mt-2" disabled={processing}>
            {processing ? "Resetting..." : "Reset password"}
          </Button>
        </div>
      </form>
    </AuthCard>
  );
}
